import { LEXICAL_NODES } from '../../../../MeetingResults/Lexical/nodes'
import { EmbeddedMeetingInfoNode } from './EmbeddedMeetingInfoNode'
import { EmbeddedParticipantsNode } from './EmbeddedParticipantsNode'
import { EmbeddedMeetingResultNode } from './EmbeddedMeetingResultNode'

export const MEETING_SUMMARY_NODES = [...LEXICAL_NODES, EmbeddedMeetingInfoNode, EmbeddedParticipantsNode, EmbeddedMeetingResultNode]
